import React from "react";
import { Logo } from "../../assets";
import { welcomeImg } from "../../assets/image";
import { ArrowForward } from "../../assets/svg/AllSvg";
import { useNavigate, useParams } from "react-router-dom";

const Welcome = () => {
  const { id, email, company } = useParams();
  const navigate = useNavigate();

  return (
    <>
      <div className="main">
        <div className="main-logo ">
          <img src={Logo} alt="logo" className="w-full h-full object-cover" />
        </div>
        <div className="center-h">
          <section className="w-full">
            <div className="max-w-xl w-full mx-auto space-y-4">
              <div className="text-center font-ebGaramond space-y-4">
                <h1 className="text-3xl text-theme">Welcome to SGCorpHub!</h1>
                <p className="text-xl">
                  We see’s that you are invited to be part of “{company}” Let’s
                  get you started now.
                </p>
              </div>
              <div className="relative w-fit h-fit">
                <img
                  src={welcomeImg}
                  alt="welcome"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex justify-center">
                <button
                  type="submit"
                  className="flex items-center text-theme space-x-2"
                  onClick={() => navigate(`/singpass/${id}/${email}`)}
                >
                  <span className="text-lg uppercase">Proceed</span>
                  <ArrowForward className="fill-theme" fill="" />
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Welcome;
